module.exports = __webpack_public_path__ + "assets/images/extra-01.90d425353dce6b152d2afd83703c6e06.svg";